import _ from 'lodash';
import { apiFetch } from '../utility';
const apiBase = 'ocrGuideDocument';

export const get = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.get`,
			params,
			dispatch,
			callback,
		});
	};
};

export const add = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.add`,
			params,
			dispatch,
			callback,
		});
	};
};
